<template>
  <div v-show="showTooltip" class="ag-grid-text-tooltip" v-html="tooltip" />
</template>
<script>

export default {
  name: 'AgGridTextTooltip',
  data() {
    return {
      tooltip: '',
      showTooltip: false
    }
  },
  mounted() {
    const gridApi = this.params.api

    const gui = gridApi.ctrlsService.gridCtrl.eGui

    if (this.params.location === 'header') {
      const headerCellSelector = `div.ag-header-viewport div[col-id="${this.params.column.colId}"] span.ag-header-cell-text`
      const cellDom = gui?.querySelector(headerCellSelector)
      if (cellDom) {
        const scrollWidth = cellDom.scrollWidth
        const clientWidth = cellDom.clientWidth
        const contentWidth = Number(clientWidth)
        this.tooltipVisible(cellDom, scrollWidth, contentWidth)
      }
    } else {
      const ellipsisCellSelector = `div[row-id="${this.params.node.id}"] div[col-id="${this.params.column.colId}"] .ag-text-ellipsis`
      const cellSelector = `div[row-id="${this.params.node.id}"] div[col-id="${this.params.column.colId}"]`

      const ellipsisCellDom = gui?.querySelector(ellipsisCellSelector)
      const cellDom = gui?.querySelector(cellSelector)

      if (ellipsisCellDom) {
        this.gridBodyTooltip(ellipsisCellDom)
      } else if (cellDom) {
        this.gridBodyTooltip(cellDom)
      }
    }
  },
  methods: {
    tooltipVisible(cellDom, scrollWidth, contentWidth) {
      if (scrollWidth > contentWidth) {
        this.tooltip = cellDom.innerHTML
        this.showTooltip = true
      }
    },
    gridBodyTooltip(cellDom) {
      const scrollWidth = cellDom.scrollWidth
      const clientWidth = cellDom.clientWidth

      const paddingRight = getComputedStyle(cellDom).paddingRight?.replace('px', '')
      const contentWidth = Number(clientWidth) + Number(paddingRight)

      this.tooltipVisible(cellDom, scrollWidth, contentWidth)
    }
  }
}
</script>

<style scoped>
.ag-grid-text-tooltip {
  padding: 6px 12px;
}
</style>
